<template>
  <div id="app">
    <router-view/>
    <dialog-box v-if="dialog.show"></dialog-box>
  </div>
</template>
 
<style lang="scss" >
@import "./static/css/front.css";

</style>

<script>
import autoRem from "@p/autoRem";
import { getHashParameter } from "@/js/tool.js";
import DialogBox from "./components/DialogBox";
import Api from "./webapi/queryApi";
import { WXObj } from "@/js/wx.js";
import { Cookie } from "@/js/util.js";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  created() {
    //this.init();
    this.$router.push({ path: "/querycode" }); 
  },
  computed: {
    ...mapState(["WX", "dialog"])

  },
  methods: {
    ...mapMutations(["set_wx"]),
    init: function() {
      this.PageInit();
    },
    PageInit: function() {
      var _ = this;
      //获取openid并设置wx
      var tokencode = getHashParameter("code");
      Api
        .get_OpenId({
          Url: window.location.href.split("#")[0],
          Code: tokencode,
          FacId: "100403",
          //OpenId: _.WX.openId
        })
        .then(res => {
          if (res.success) {
            _.set_wx(res.result);
            _.$router.push({ path: "/querycode" }); 
          } else {
            alert("未获取到关键参数");
          }
        })
        .then(res => {
          if (_.WX.appid) {
            WXObj.WXSetting(_.WX);
            // setTimeout(() => {
            //   _.getlocation();
            // }, 1000);
          }
        });
    },
    getlocation: function() {
      WXObj.getLocation(function(IsGps, res) {
        Cookie.setCookie('gps',JSON.stringify(res));
      });
    }
  },
  components: {
    DialogBox
  }
};
</script>


